(function (appComponents) {

	var pageAccessRules = function (parent) {
		var pageAccessRules = {};

		pageAccessRules.parent = parent;

		pageAccessRules._utils = parent._utils;
		pageAccessRules._cart = parent._cart;
		pageAccessRules._b2bUnit = parent._b2bUnit;
		pageAccessRules._modals = parent._modals;
		pageAccessRules._messages = parent._messages;
		pageAccessRules._stash = parent._stash;

		pageAccessRules._goToPage = parent._goToPage;

		pageAccessRules.checkIfQueryDataIsSet = function (params) {
			var queryData = pageAccessRules.parent._queryData;

			if ((queryData != null && Object.keys(queryData).length != 0) || params != null) {
				return true;
			} else {
				return false;
			}
		};

		pageAccessRules.rulesList = {
			checkoutProfile: function () {
				if (!pageAccessRules._b2bUnit.isUnitSet) {
					pageAccessRules._b2bUnit.elements.headerDisplay.click();
					return false;
				}
			},
			searchResults: function (params) {
				var isQueryDataSet = pageAccessRules.checkIfQueryDataIsSet(params);

				if (!isQueryDataSet) {
					pageAccessRules.parent._goToPage("index");
					return false;
				}
			},
			quoteDetails: function (params) {
				var isQueryDataSet = pageAccessRules.checkIfQueryDataIsSet(params);

				if (!isQueryDataSet) {
					pageAccessRules.parent._goToPage("quotesOverview");
					return false;
				}
			},
			orderDetails: function (params) {
				var isQueryDataSet = pageAccessRules.checkIfQueryDataIsSet(params);

				if (!isQueryDataSet) {
					pageAccessRules.parent._goToPage("ordersOverview");
					return false;
				}
			},
			cartOverview: function () {
				if (pageAccessRules.parent._page.title == "cartOverview" && pageAccessRules._cart.cartSize == 0) {
					pageAccessRules._goToPage("index");
					return false;
				}
				if (pageAccessRules._cart.cartSize == 0) {
					pageAccessRules._modals.warning.show(pageAccessRules._messages.cartIsEmpty);
					return false;
				}
			},
			quoteCheckout: function () {
				if (pageAccessRules._cart.cartSize == 0) {
					pageAccessRules._goToPage("index");
					return false;
				}
				if (!pageAccessRules._b2bUnit.isUnitSet) {
					pageAccessRules._b2bUnit.elements.headerDisplay.click();
					return false;
				}
			},
			orderCheckout: function () {
				if (pageAccessRules._cart.cartSize == 0) {
					pageAccessRules._goToPage("index");
					return false;
				}
				if (!pageAccessRules._b2bUnit.isUnitSet) {
					pageAccessRules._b2bUnit.elements.headerDisplay.click();
					return false;
				}
			},
			errorPage: function () {
				if (pageAccessRules._stash.error == null) {
					pageAccessRules._goToPage("index");
					return false;
				}
			},

			commonPageCheck: function (path, params) {
				var pagesToIgnore = ["searchResults", "cartOverview", "orderCheckout", "quoteCheckout"];
 				if (parent._page.paths.indexOf(path) > -1 && pagesToIgnore.indexOf(parent._page.title) < 0) {
					return false;
				} else {
					return true;
				} 
			}
		};

		pageAccessRules.checkByPageTitle = function (title) {
			var access = true;
			if (pageAccessRules.rulesList[title] != null) {
				access = pageAccessRules.rulesList[title]();
			}

			return (access === false) ? false : true;
		};

		pageAccessRules.checkByPagePath = function (path, params) {
			var access = true;
			var pageData = pageAccessRules._utils.findPageByPath(path);
			if (access = pageAccessRules.rulesList.commonPageCheck(path, params)) {

				if (pageAccessRules.rulesList[pageData.title] != null) {
					access = pageAccessRules.rulesList[pageData.title](params);
				}

			}

			return (access === false) ? false : true;
		};

		return pageAccessRules;
	};


	if (appComponents.pageComponents == null) appComponents.pageComponents = {};
	if (appComponents.pageComponents.layout == null) appComponents.pageComponents.layout = {};
	appComponents.pageComponents.layout.pageAccessRules = pageAccessRules;

	window.appComponents = appComponents;

})(window.appComponents || {});